import { elements } from '@ecosystem/newron-design-system';
import React from 'react';
import { useMobile } from '../../context/mobile/mobile.provider';
import { MenuButtonProps } from '../selection.menu';

const { Icon } = elements;

export const TitleButton: React.FC<MenuButtonProps> = ({ onClick, children, disabled }) => {
  const { isMobile } = useMobile();

  const baseClassNames = `relative rounded text-left ${
    isMobile ? 'text-md' : 'text-lg'
  } p-0 flex items-center transition-colors`;
  const enabledClassNames = 'text-brand hover:bg-brand-lightest hover:text-brand-dark';
  const disabledClassNames = 'text-inactive cursor-not-allowed';

  const className = `${baseClassNames} ${!disabled ? enabledClassNames : disabledClassNames}`;

  const iconColor = disabled ? 'inactive' : 'brand';

  const ChevronDownIcon = Icon.icons['ChevronDown'];

  return (
    <button className={className} style={{ boxShadow: 'none' }} disabled={disabled} onClick={onClick}>
      <span className="flex-grow nowrap">{children}</span>
      <Icon testId="icon-chevron-down" color={iconColor} size="sm">
        <ChevronDownIcon />
      </Icon>
    </button>
  );
};
